import { render, staticRenderFns } from "./administratorCreationView.vue?vue&type=template&id=322cfa0a&scoped=true&"
import script from "./administratorCreationView.vue?vue&type=script&lang=js&"
export * from "./administratorCreationView.vue?vue&type=script&lang=js&"
import style0 from "./administratorCreationView.vue?vue&type=style&index=0&id=322cfa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cfa0a",
  null
  
)

export default component.exports